import React from "react";
import KeyIcon from "./KeyIcon";
import ColumnHeader from "./ColumnHeader";

interface Props {
  numTimeSteps: number;
}

/**
 * The `timestep` input relation: one row per hour of the optimization horizon.
 * Its single key column `t` is the hour index the other tables (demand, and the
 * decision variables) join against.
 */
const TimestepTable: React.FC<Props> = ({ numTimeSteps }) => {
  const thStyle: React.CSSProperties = {
    background: "#f5f5f5",
    padding: "8px",
    textAlign: "left",
    borderBottom: "1px solid #ddd",
    fontWeight: "bold",
  };
  const tdStyle: React.CSSProperties = { padding: "6px 8px", borderBottom: "1px solid #eee" };

  return (
    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px", marginTop: "10px" }}>
      <thead>
        <tr>
          <ColumnHeader column="t" style={thStyle}>
            t<KeyIcon />
          </ColumnHeader>
          <th style={thStyle}>hour</th>
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: numTimeSteps }, (_, t) => (
          <tr key={t}>
            <td style={tdStyle}>{t}</td>
            <td style={tdStyle}>{`${String(t).padStart(2, "0")}:00`}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TimestepTable;
